export function isBlob(uri: string) {
  return uri.startsWith("blob:");
}
